import React from 'react';


import {ResponsiveElementGroup} from 'src/components/responsive-element-group';
import {FormItemSkeleton, FormSectionSkeleton, InputSkeleton} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';

export const DealCloudSectionSkeleton = () => (
    <Group direction="v" gap="l">
        <FormSectionSkeleton labelWidth={110}>
            <ResponsiveElementGroup>
                <FormItemSkeleton labelWidth={76}>
                    <InputSkeleton labelWidth={300}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={106}>
                    <InputSkeleton labelWidth={300}/>
                </FormItemSkeleton>
            </ResponsiveElementGroup>
        </FormSectionSkeleton>
    </Group>
);
